
import { Component, OnInit } from '@angular/core';
// import { FormBuilder,FormControl,FormGroup,Validators,} from "@angular/forms";
import { LoginService } from "../ApplicationServices/LoginService";
//import { FormGroup, FormControl, FormBuilder, FormArray } from "@angular/forms";
import { FormGroup, FormControl, FormBuilder, FormArray } from "@angular/forms";
import { CollectionService } from '../ApplicationServices/CollectionService';

@Component({
  selector: 'app-hideandskincustomization',
  templateUrl: './hideandskincustomization.component.html',
  styleUrls: ['./hideandskincustomization.component.scss']
})

export class HideandskincustomizationComponent implements OnInit {

  count : number=0;

  FN: string; LN: string; CN: string; EI: string;
  ME: string; SU: string; 
  //alertmsg: string; alertmsg: string;

  videoForm: FormGroup;
  acceptVideo = "video/*";

  registerForm: FormGroup;
  alertmsg: string;
  showAlert: boolean;

  constructor
  (

    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private fb: FormBuilder,
    // private uploadsvc: UploadService,
    private collservice : CollectionService,

  ) 
  {

    this.videoForm = new FormGroup({
      videoList: this.fb.array([
        this.fb.group({

          // video: new FormControl(),
          // //ImageCategoryId: new FormControl(),
          // ItemVariationId4: new FormControl(),
          // Serial1: new FormControl(),

          firstnames: new FormControl(),
          lastnames: new FormControl(),     
          emails: new FormControl(),
          contactnos: new FormControl(),
          video: new FormControl(),
          subjects: new FormControl(),
          messages: new FormControl(),


        }),
      ]),
    });

  }

  ngOnInit(): void {


    
    this.registerForm = this.formBuilder.group({

      firstnames: new FormControl(),
      lastnames: new FormControl(),     
      emails: new FormControl(),
      contactnos: new FormControl(),
      video: new FormControl(),
      subjects: new FormControl(),
      messages: new FormControl(),
     
    });



  }


  
  onRegister() {
    

    if( 

      this.registerForm.value.firstnames=='' || this.registerForm.value.lastnames==''  || 
      this.registerForm.value.emails=='' || this.registerForm.value.contactnos=='' || 
      this.registerForm.value.subjects=='' || this.registerForm.value.subjects==''  

      ){

      this.alertmsg = "Access denied , all fields must be filled up !";
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
     // return;

    }
    
    else
    {


      const formData = new FormData();
      var obj = {
       
        UserFirstName: this.registerForm.value.firstnames,
        UserLastName: this.registerForm.value.lastnames,
        UserEmail: this.registerForm.value.emails,
        UserContactNo: this.registerForm.value.contactnos,
        Video: this.registerForm.value.video,
        UserSubject: this.registerForm.value.subjects,
        UserMessage: this.registerForm.value.messages,
        // OperationType: "INSERT",
        // Notes: "WEBSITE",

      };
      formData.append("params", JSON.stringify(obj));
      this.loginService.sendqueryCustomizeOrdersubmit(obj).subscribe((event: any) => {
        if (event && event.length > 0) {
          console.log(event);

          //this.alertmsg = event[0].OperationStatus;
          this.alertmsg = "Message is send successfully !";
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 3000);

          this.registerForm.reset();


        }
      });


    }


  }




  
  onVideoListSubmit(res) {

  

     this.count=0;
  
    
     //this.FN=res.firstnames;
    // this.FN=this.videoForm.;
    
    console.log(res);
    var imgforid = 2, other = []; 
    var ids=0;

    
    if (res.videoList.length > 0) {
      const formData = new FormData();
      res.videoList.forEach((element) => {


        if(  

          element.firstnames =="" ||  element.firstnames ==null ||
          element.lastnames =="" ||  element.lastnames ==null ||
          element.emails =="" ||  element.emails ==null ||
          element.contactnos =="" ||  element.contactnos ==null ||
          element.subjects =="" ||  element.subjects ==null ||
          element.messages =="" ||  element.messages ==null ||
          element.video.name == "" ||  element.video.name == null ||
          element.video == "" ||  element.video == null
          
          ){

          this.alertmsg = "All Fields Are Mandatory !";
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 3000);

          return;

          }
          else{

            if (element.video) {
              other.push({
             
                FirstNames: element.firstnames,
                LastNames: element.lastnames,
                Emails: element.emails,
                Contactnos: element.contactnos,
                Subjects: element.subjects,
                Messages: element.messages,
                Name: element.video.name,        
               
              });
             
            }

            this.count=1;
            this.alertmsg = "Message is sending , Please wait ......";
            this.showAlert = true;    
    
            formData.append("file", element.video);  


          }    
       
        

      });

      if( this.count==1  ){


        formData.append("params", JSON.stringify(other));

        this.collservice.uploadData(formData).subscribe((event: any) => {
          if (typeof event === "object" && event.status == 200) {
            console.log(event);
  
            // this.alertmsg2 = "Saved Successfully !";
            // this.showalert2 = true;
            // setTimeout(() => {
            //   this.showalert2 = false;
            // }, 2000);
  
            this.alertmsg = "Message is send successfully !";
            this.showAlert = true;
            setTimeout(() => {
              this.showAlert = false;
            }, 3000);
  
          }
  
          //this.showLoader2 = false;
  
        });

          

      }
      else{

        this.alertmsg = "Fill Up All Fields Properly !";
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);



      }
     
     

    }

    //this.showLoader4 = false;
    //this.GetAllMethod();

  }

  get videoList() {
    return this.videoForm.get("videoList") as FormArray;
  }

  addVideoList() {
    this.videoList.push(
      this.fb.group({
        
        //video: new FormControl(),
        //ImageCategoryId: new FormControl(),
        // SKUCode:new FormControl()
        //ItemVariationId4: new FormControl(),
        //Serial1: new FormControl(),

           // firstnames: new FormControl(),
          // lastnames: new FormControl(),     
         // emails: new FormControl(),
        //contactnos: new FormControl(),
        video: new FormControl(),
        // subjects: new FormControl(),
       // messages: new FormControl(),

      })
    );
  }
  deleteVideoList(index) {
    this.videoList.removeAt(index);
  }




}
